// Kakao Template Categories from API
interface TemplateCategory {
  code: string;
  name: string;
  groupName: string;
}

interface TemplateCategoriesMap {
  [key: string]: TemplateCategory;
}

interface CategoryGroupsMap {
  [groupName: string]: TemplateCategory[];
}

const TEMPLATE_CATEGORIES: TemplateCategoriesMap = {
  // Member categories (회원)
  "001001": { code: "001001", name: "회원가입", groupName: "회원" },
  "001002": { code: "001002", name: "인증/비밀번호/로그인", groupName: "회원" },
  "001003": { code: "001003", name: "회원정보/회원혜택", groupName: "회원" },
  
  // Purchase categories (구매)
  "002001": { code: "002001", name: "구매완료", groupName: "구매" },
  "002002": { code: "002002", name: "상품가입", groupName: "구매" },
  "002003": { code: "002003", name: "진행상태", groupName: "구매" },
  "002004": { code: "002004", name: "구매취소", groupName: "구매" },
  "002005": { code: "002005", name: "구매예약/입고알림", groupName: "구매" },
  
  // Reservation categories (예약)
  "003001": { code: "003001", name: "예약완료/예약내역", groupName: "예약" },
  "003002": { code: "003002", name: "예약상태", groupName: "예약" },
  "003003": { code: "003003", name: "예약취소", groupName: "예약" },
  "003004": { code: "003004", name: "예약알림/리마인드", groupName: "예약" },
  
  // Service usage categories (서비스이용)
  "004001": { code: "004001", name: "이용안내/공지", groupName: "서비스이용" },
  "004002": { code: "004002", name: "신청접수", groupName: "서비스이용" },
  "004003": { code: "004003", name: "처리완료", groupName: "서비스이용" },
  "004004": { code: "004004", name: "이용도구", groupName: "서비스이용" },
  "004005": { code: "004005", name: "방문서비스", groupName: "서비스이용" },
  "004006": { code: "004006", name: "피드백 요청", groupName: "서비스이용" },
  "004007": { code: "004007", name: "구매감사/이용확인", groupName: "서비스이용" },
  "004008": { code: "004008", name: "리마인드", groupName: "서비스이용" },
  
  // Reporting categories (리포팅)
  "005001": { code: "005001", name: "피드백", groupName: "리포팅" },
  "005002": { code: "005002", name: "요금청구", groupName: "리포팅" },
  "005003": { code: "005003", name: "계약/견적", groupName: "리포팅" },
  "005004": { code: "005004", name: "안전/피해예방", groupName: "리포팅" },
  "005005": { code: "005005", name: "뉴스레터", groupName: "리포팅" },
  "005006": { code: "005006", name: "거래알림", groupName: "리포팅" },
  
  // Delivery categories (배송)
  "006001": { code: "006001", name: "배송상태", groupName: "배송" },
  "006002": { code: "006002", name: "배송예정", groupName: "배송" },
  "006003": { code: "006003", name: "배송완료", groupName: "배송" },
  "006004": { code: "006004", name: "배송실패", groupName: "배송" },
  
  // Legal notice categories (법적고지)
  "007001": { code: "007001", name: "수신동의", groupName: "법적고지" },
  "007002": { code: "007002", name: "개인정보", groupName: "법적고지" },
  "007003": { code: "007003", name: "약관변경", groupName: "법적고지" },
  "007004": { code: "007004", name: "휴면 관련", groupName: "법적고지" },
  
  // Business notification categories (업무알림)
  "008001": { code: "008001", name: "주문/예약", groupName: "업무알림" },
  "008002": { code: "008002", name: "내부 업무 알림", groupName: "업무알림" },
  
  // Coupon/Point categories (쿠폰/포인트)
  "009001": { code: "009001", name: "쿠폰발급", groupName: "쿠폰/포인트" },
  "009002": { code: "009002", name: "쿠폰사용", groupName: "쿠폰/포인트" },
  "009003": { code: "009003", name: "포인트적립", groupName: "쿠폰/포인트" },
  "009004": { code: "009004", name: "포인트사용", groupName: "쿠폰/포인트" },
  "009005": { code: "009005", name: "쿠폰/포인트안내", groupName: "쿠폰/포인트" },
  
  // Other
  "999999": { code: "999999", name: "기타", groupName: "기타" }
};

// Group categories for select dropdown
const CATEGORY_GROUPS: CategoryGroupsMap = Object.values(TEMPLATE_CATEGORIES).reduce((groups: CategoryGroupsMap, category: TemplateCategory) => {
  const groupName = category.groupName;
  if (!groups[groupName]) {
    groups[groupName] = [];
  }
  groups[groupName].push(category);
  return groups;
}, {});

export { TEMPLATE_CATEGORIES, CATEGORY_GROUPS };